import { render } from "./ForgotPassword2View.vue?vue&type=template&id=63d9153e"
import script from "./ForgotPassword2View.vue?vue&type=script&lang=js"
export * from "./ForgotPassword2View.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__